import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './avatar.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [AvatarComponent],
  imports: [CommonModule, 
            AngularSvgIconModule,
            MatTooltipModule],
  exports: [AvatarComponent],
})
export class AvatarModule {}
